var createStylesheet = (chunkId, fullhref, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	(function(linkTag) {
	                if (typeof _N_E_STYLE_LOAD === 'function') {
	                    const { href, onload, onerror } = linkTag;
	                    _N_E_STYLE_LOAD(href.indexOf(window.location.origin) === 0 ? new URL(href).pathname : href).then(()=>onload == null ? void 0 : onload.call(linkTag, {
	                            type: 'load'
	                        }), ()=>onerror == null ? void 0 : onerror.call(linkTag, {}));
	                } else {
	                    document.head.appendChild(linkTag);
	                }
	            })(linkTag)
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	8068: 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"8":1,"25":1,"110":1,"224":1,"563":1,"691":1,"819":1,"1156":1,"1171":1,"1235":1,"1247":1,"1352":1,"1356":1,"1453":1,"1545":1,"1623":1,"1634":1,"1887":1,"1964":1,"2073":1,"2155":1,"2200":1,"2279":1,"2301":1,"2323":1,"2362":1,"2508":1,"2536":1,"2694":1,"2764":1,"2781":1,"3055":1,"3098":1,"3248":1,"3309":1,"3366":1,"3373":1,"3618":1,"3822":1,"3823":1,"4060":1,"4287":1,"4476":1,"4499":1,"4541":1,"4547":1,"4617":1,"4704":1,"4706":1,"4902":1,"4915":1,"5274":1,"5301":1,"5303":1,"5356":1,"5432":1,"5460":1,"5540":1,"5663":1,"5698":1,"5757":1,"5767":1,"5769":1,"5781":1,"5853":1,"6075":1,"6116":1,"6232":1,"6284":1,"6403":1,"6499":1,"6507":1,"6562":1,"6631":1,"6655":1,"6671":1,"6761":1,"6780":1,"6828":1,"6856":1,"6862":1,"7221":1,"7289":1,"7367":1,"7454":1,"7455":1,"7470":1,"7640":1,"7680":1,"7684":1,"7899":1,"8051":1,"8131":1,"8141":1,"8146":1,"8197":1,"8241":1,"8271":1,"8275":1,"8280":1,"8355":1,"8360":1,"8485":1,"8883":1,"8887":1,"9079":1,"9102":1,"9114":1,"9129":1,"9201":1,"9460":1,"9740":1,"9770":1,"9908":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr